/**
 * @desc 保存或者修改
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.LogisticsQuotationTobRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsQuotationTob/saveOrUpdate`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
